export const login = {

    welcomeText: 'Welcome speKwo Pro!',
    welcome2Text: 'Log in here to check your work, update your profile',

    username: 'USER NAME',
    usernameReq: 'Username is required',
    usernameInvalid: 'Please enter a valid username',

    password: 'PASSWORD',
    passwordReq: 'Password is required',
    showPassword: 'Show password!',
    hidePassword: 'Hide password!',

    login: 'LOGIN',
    or: 'OR',
    haveAccount: "Not a verified speKwo Pro yet,",
    create: 'Sign up here!',
    createTooltip: 'Click here',
    footer: 'Need assistance? Just give us a call 866.646.0200 or prohelp@speKwo.com',
}

export const resetPwd = {
    reset: 'Reset Password?',
    resetHead: 'RESET YOUR PASSWORD',

    email: 'Email',
    emailRequired: 'Email is required',
    emailInvalid: 'Please enter a valid email address',
    emailExist: 'Email does not exist',

    password: 'Password',
    passwordRequired: 'Password is required',

    passwordConfirm: 'Password (Confirm)',
    passwordConRequired: 'Password confirmation is required',
    passwordMismatch: 'Passwords must match',

    resetBtn: 'RESET MY PASSWORD',
    login: 'Login here!',
    loginTooltip: 'Click here'
}

export const register = {
    welcome: 'Welcome to speKwo',
    heading: 'CREATE AN ACCOUNT',
    updateHead: 'UPDATE AN ACCOUNT',

    firstname: 'First name',
    firstnameRequired: 'First name is required',

    lastname: 'Last name',
    lastnameRequired: 'Last name is required',

    email: 'Email',
    emailRequired: 'Email is required',
    emailInvalid: 'Please enter a valid email address',
    emailExist: 'Email is already exist',

    password: 'Password',
    passwordRequired: 'Password is required',

    passwordConfirm: 'Password (Confirm)',
    passwordConRequired: 'Password confirmation is required',
    passwordMismatch: 'Passwords must match',

    accept: 'Accept',
    terms: 'terms and conditions',
    createBtn: 'SIGN UP',
    alreadyhave: 'verified speKwo Pro?',
    login: 'Login here!',
    loginTooltip: 'Click here',
}


// WEBPACK FOOTER //
// E:/NeoSME/1.Full Project Spekwo/pro/prodash/src/app/main/content/apps/utils/auth.ts